/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import TableViewPopup from "../TableViewPopup/TableViewPopup";
import ViewVendorPopup from "../../pages/vendors/viewVendorPopup";
import ViewFeedbackPopup from "../../pages/feedback/viewFeedbackPopup";
import ViewPayoutPopup from "../../pages/payoutRequests/viewPayoutReqPopup";
import ViewDrinkTypePopup from "../../pages/drinktypes/viewDrinkTypePopup";
import ViewEnquiryPopup from "../../pages/contactus/viewContactusPopup";
import ViewCampaignSupportPopup from "../../pages/campaignSupport/viewCampaignSupportPopup";
import ViewCafePopup from "../../pages/cafes/viewCafePopup";
import styles from "./ActionButtons.module.scss";
import useToggle from "../../hooks/useToggle";
import { Entry } from "../../redux/entrySlice";
import { TableContext } from "../../contexts/tableContext";
import { getCookies, getPermissions } from "../../hooks/useCookies";
import EditUserPopup from "../../pages/users/editUserPopUp";
import EditAdminUserPopup from "../../pages/adminusers/editUserPopUp";
import EditVendorPopup from "../../pages/vendors/editUserPopUp";
import EditCafePopup from "../../pages/cafes/editCafePopUp";
import EditDrinkTypePopup from "../../pages/drinktypes/editDrinktypePopup";
import MenuEdit from "../../pages/menus/editMenuPopUp";
import ViewMenuPopup from "../../pages/menus/viewMenuPopup";
import ViewClaimRequestPopup from "../../pages/claimRequests/viewClaimReqPopup";
import ClaimReqDetailsPopup from "../../pages/claimRequests/ClaimReqDetailsPopup";
import EditCouponPopUp from "../../pages/coupons/editCouponPopUp";
import ViewIssuePopup from "../../pages/issues/viewIssuePopup";
import ParticipationReqPopup from "../../pages/participationRequests/ParticipationReqDetailsPopup";
import ViewTicketPopup from "../../pages/tickets/viewTicketPopup";
import EditCategoryPopup from "../../pages/category/editCategoryPopup";
import ViewSuggestionPopup from "../../pages/suggestions/viewSuggestionPopup";
import ViewSuggestedEditPopup from "../../pages/suggestedEdits/viewSuggestedEditpopup";

import CoffeeRewardPopup from "../../pages/coffeeCredits/viewCoffeeRewardPopup";
import OrdersPopup from "../../pages/orders/ordersPopup";
import FindSimilarCafesModal from "../../pages/mergerequests/findSimilarCafesModal";
import SuggestMergeModal from "../../pages/mergerequests/suggestMergeModal";
import EditAppVersionPopup from "../../pages/appVersions/editAppVersionPopup";
import WalletBalanceModal from "../../pages/users/walletBalanceModal";
import CafeTransactionReportModal from "../../pages/cafes/CafeTransactionReportModal";

function ActionButtons({
  data,
  section,
  claimCafeId,
  viewPopUp,
  deleteCondition,
  setTableData,
  setIsUpdated,
  edit = false,
  status,
  permission,
  posConnected,
}) {
  console.log("section-=", section);
  const { actionbtnStyle } = useContext(TableContext);
  const [actionPermissions, setActionPermission] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [, setDeletemessage] = useState();
  const [canDelete, setCanDelete] = useState(true);
  const { setDeletedData } = useContext(TableContext);
  const [showTablePopUp, setShowTablePopUp] = useToggle();
  const { dashUpdate, setDashUpdate, setActionReject } =
    useContext(TableContext);

  // Track whether "view" or "edit" is selected
  const [action, setAction] = useState("view");
  const [selectedCafeId, setSelectedCafeId] = useState();
  const [showOrdersPopup, setShowOrdersPopup] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedType, setSelectedType] = useState(null);

  // Merge-related state
  const [showSimilarCafes, setShowSimilarCafes] = useState(false);
  const [showSuggestMerge, setShowSuggestMerge] = useState(false);
  const [selectedTargetCafe, setSelectedTargetCafe] = useState(null);
  const [showWalletModal, setShowWalletModal] = useState(false);
  const [showTransactionReportModal, setShowTransactionReportModal] =
    useState(false);

  // Function for "view" action
  const actionView = (param) => (event) => {
    event.preventDefault();
    setAction("view");
    const encodeText = param.id;
    if (viewPopUp) {
      setShowTablePopUp(true);
    } else {
      navigate(`/${section}/viewdetails/${encodeText}`);
    }
  };

  // Function for "edit" action
  const actionEdit = (data) => {
    setAction("edit"); // Set action to "edit"
    const encodeText = data.id;
    if (viewPopUp) {
      setShowTablePopUp(true);
    } else {
      navigate(`/${section}/editdetails/${encodeText}`);
    }
  };

  const handleAddCoffeeCredit = (data) => {
    setShowTablePopUp(true);
  };
  const getSection=(section)=>{
    if(section === 'mergerequests')
      return 'cafe/merge-requests';
    return section;
  }
  // Handle delete action
  const handleDelete = (params) => {
    const name = data.name ? data.name : data.type;
    const drinkNames = data.drinkNames;
    const deleteMessage =
      section === "menus"
        ? "Menu deleted successfully."
        : section === "vendor"
        ? "Vendor deleted successfully."
        : section === "user"
        ? "User deleted successfully."
        : section === "cafe"
        ? "Cafe deleted successfully."
        : section === "claimrequests"
        ? "Claim request deleted successfully."
        : section === "feedback"
        ? "Feedback deleted successfully."
        : section === "payoutrequests"
        ? "Payout request deleted successfully."
        : section === "drinktypes"
        ? "Drink type deleted successfully."
        : section === "coupons"
        ? "Coupon deleted successfully."
        : section === "enquiries"
        ? "Inquiry deleted successfully."
        : "Item deleted successfully.";

    let message = `Are you sure you want to delete ${name}?`;
    let drinkList;
    if (data.totalDrinks > 0) {
      drinkList =
        drinkNames.length > 0
          ? drinkNames.slice(0, 3).join(", ") +
            (data.totalDrinks > 3 ? ", and more" : "")
          : "no drink names available";
    }

    confirmAlert({
      title: canDelete ? "" : "Oops!!",
      message: (
        <div>
          {/* {data.totalDrinks > 0 && (
            <p>There are {data.totalDrinks} drink(s) using this drink type.</p>
          )}
          {drinkList && <p>Drinks associated: {drinkList}.</p>} */}
          <p>Are you sure you want to delete {name}?</p>
        </div>
      ),
      buttons: canDelete
        ? [
            {
              label: "Yes",
              onClick: () => {
                const actionData = {};
                const deleteId = data._id ?? data.id;
                actionData.actionUrl = `${getSection(section)}/${deleteId}`;
                actionData.actionMethod = "delete";
                dispatch(Entry(actionData)).then((resp) => {
                  if (resp.payload.code === 400) {
                    confirmAlert({
                      title: "Oops! Cannot Delete!",
                      message: resp.payload.message,
                      buttons: [{ label: "Ok" }],
                    });
                  } else {
                    toast.success(deleteMessage);
                    setDeletedData(`data last deleted is ${deleteId}`);
                    // setTableData((prevData) =>
                    //   prevData.filter((item) => item.id !== deleteId)
                    // );
                    if (!dashUpdate) {
                      setDashUpdate(true);
                    }
                    setIsUpdated(true);
                  }
                });
              },
            },
            {
              label: "No",
            },
          ]
        : [{ label: "Ok" }],
    });
  };

  // Check user permissions and delete condition
  useEffect(() => {
    const temp = section.replace(/\s+/g, "").toLowerCase();
    const permissions = getPermissions();
    permissions.forEach((val) => {
      if (val.section.toLowerCase() === temp) {
        setActionPermission({
          view: val.view ? val.view : false,
          edit: val.edit ? val.edit : false,
          create: val.create ? val.create : false,
          delete: val.delete ? val.delete : false,
          approve: val.approve ? val.approve : false,
        });
      } else if (val.submenu) {
        val.submenu.forEach((element) => {
          if (element.section?.toLowerCase() === temp) {
            setActionPermission({
              view: element.view ? element.view : false,
              edit: element.edit ? element.edit : false,
              create: element.create ? element.create : false,
              delete: element.delete ? element.delete : false,
              approve: element.approve ? element.approve : false,
            });
          }
        });
      }
    });
    if (deleteCondition.checkCondition) {
      setCanDelete(false);
      setDeletemessage("Sorry you cant delete this data");
    }
  }, []);

  console.log("Action permissions--", actionPermissions);

  const handleReject = async (id) => {
    let rejectionNotes = "";
    
    confirmAlert({
      title: "Reject Cafe Application",
      message: "Please provide detailed feedback for the vendor (minimum 10 characters):",
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body">
            <h1>Reject Cafe Application</h1>
            <p>Please provide detailed feedback for the vendor:</p>
            <textarea
              id="rejectionNotesInput"
              className="form-control"
              rows={4}
              placeholder="Please provide detailed feedback for the vendor..."
              style={{ width: "100%", marginBottom: "15px" }}
            />
            <div className="react-confirm-alert-button-group">
              <button
                className="btn btn-danger"
                onClick={() => {
                  const notes = document.getElementById("rejectionNotesInput").value;
                  if (!notes || notes.trim().length < 10) {
                    toast.warning("Please provide at least 10 characters of feedback");
                    return;
                  }
                  
                  const actionData = {
                    actionUrl: `cafe/reject-cafe/${id}`,
                    actionMethod: "post",
                    apiData: { notes },
                  };
                  
                  dispatch(Entry(actionData))
                    .then(() => {
                      setActionReject((prev) => prev + 1);
                      toast.success("Cafe request rejected successfully");
                      if (!dashUpdate) {
                        setDashUpdate(true);
                      }
                      setIsUpdated(true);
                      onClose();
                    })
                    .catch((err) => {
                      toast.error("Error rejecting cafe request");
                      console.error("Error: ", err);
                    });
                }}
              >
                Confirm Rejection
              </button>
              <button className="btn btn-secondary" onClick={onClose}>
                Cancel
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const handleApprove = async (id) => {
    // Check if application is rejected
    if (data?.applicationStatus && data.applicationStatus === "Rejected") {
      confirmAlert({
        title: "Application Rejected",
        message: "This café's application has been rejected. The vendor must resubmit their application with the required updates before it can be approved.",
        buttons: [
          {
            label: "View Application Details",
            onClick: () => {
              navigate(`/vendorapplications/viewdetails/${id}`);
            },
          },
          {
            label: "Close",
          },
        ],
      });
      return;
    }

    // If this cafe has an applicationStatus, show dialog to redirect to vendor applications
    if (data?.applicationStatus && (data.applicationStatus === "Submitted" || data.applicationStatus === "In Review")) {
      confirmAlert({
        title: "Review Application Documents",
        message: "Please review and approve all application documents first from the Vendor Applications section.",
        buttons: [
          {
            label: "Go to Application Details",
            onClick: () => {
              navigate(`/vendorapplications/viewdetails/${id}`);
            },
          },
          {
            label: "Cancel",
          },
        ],
      });
      return;
    }

    confirmAlert({
      title: canDelete ? "" : "Oops!!",
      message: "Are you sure you want to approve the cafe request?",
      buttons: canDelete
        ? [
            {
              label: "Yes",
              onClick: () => {
                const actionData = {};
                actionData.actionUrl = `cafe/approve-cafe/${id}`;
                actionData.actionMethod = "post";
                dispatch(Entry(actionData))
                  .then(() => {
                    setActionReject((prev) => prev + 1);
                    toast.success("Cafe request approved successfully");
                    setIsUpdated(true);
                    if (!dashUpdate) {
                      setDashUpdate(true);
                    }
                  })
                  .catch((err) => {
                    toast.error("Error approving cafe request: ");
                    console.error("Error: ", err);
                  });
              },
            },
            {
              label: "No",
              // onClick: () => alert("Click No")
            },
          ]
        : [
            {
              label: "Ok",
              // onClick: () => alert("Click No")
            },
          ],
    });
  };

  const handleDuplicateCafe = async (id) => {
    confirmAlert({
      title: canDelete ? "" : "Oops!!",
      message:
        "Are you sure you want to duplicate this café along with its menu and settings?",
      buttons: canDelete
        ? [
            {
              label: "Yes",
              onClick: () => {
                const actionData = {};
                actionData.actionUrl = `cafe/duplicate-cafe/${id}`;
                actionData.actionMethod = "post";
                dispatch(Entry(actionData))
                  .then((data) => {
                    console.log("Dataa ===", data.payload.data.result.id);
                    setSelectedCafeId(data.payload.data.result.id);
                    setShowTablePopUp(true);
                    // setActionReject((prev) => prev + 1);
                    // toast.success("Duplicate cafe created successfully");
                    // setIsUpdated(true);
                    // if (!dashUpdate) {
                    //   setDashUpdate(true);
                    // }
                  })
                  .catch((err) => {
                    toast.error("Error creating duplicate cafe");
                    console.error("Error: ", err);
                  });
              },
            },
            {
              label: "No",
              // onClick: () => alert("Click No")
            },
          ]
        : [
            {
              label: "Ok",
              // onClick: () => alert("Click No")
            },
          ],
    });
  };

  const handleOrdersClickCafe = (cafeId) => {
    setSelectedUserId(cafeId);
    setShowOrdersPopup(true);
    setSelectedType("cafe");
  };

  const handleOrdersClick = (userId) => {
    setSelectedUserId(userId);
    setShowOrdersPopup(true);
    setSelectedType("user");
  };

  // Handle selecting a cafe from FindSimilarCafesModal to suggest merge
  const handleSelectCafeForMerge = (targetCafe) => {
    setSelectedTargetCafe(targetCafe);
    setShowSimilarCafes(false);
    setShowSuggestMerge(true);
  };

  const handleReward = async (id) => {
    confirmAlert({
      title: canDelete ? "" : "Oops!!",
      message: "Are you sure you want to reward $100?",
      buttons: canDelete
        ? [
            {
              label: "Yes",
              onClick: () => {
                const actionData = {};
                actionData.actionUrl = `cafe/initiate-reward/${id}`;
                actionData.actionMethod = "post";
                actionData.apiData = { amount: 100, type: "suggestion" };
                dispatch(Entry(actionData))
                  .then((data) => {
                    console.log("Dataa ===", data?.payload);
                    // setShowTablePopUp(true);
                    // setActionReject((prev) => prev + 1);
                    // toast.success("Duplicate cafe created successfully");
                    setIsUpdated(true);
                    // if (!dashUpdate) {
                    //   setDashUpdate(true);
                    // }
                  })
                  .catch((err) => {
                    toast.error("Error rewarding $100");
                    console.error("Error: ", err);
                  });
              },
            },
            {
              label: "No",
              // onClick: () => alert("Click No")
            },
          ]
        : [
            {
              label: "Ok",
              // onClick: () => alert("Click No")
            },
          ],
    });
  };

  const handleDeleteSuggestion = (id, cafeName) => {
    confirmAlert({
      title: "",
      message: `Are you sure you want to delete the suggested cafe "${cafeName || "this suggestion"}"?`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            const actionData = {
              actionUrl: `cafe/suggested-cafe/${id}`,
              actionMethod: "delete",
            };
            dispatch(Entry(actionData))
              .then((resp) => {
                if (resp.payload?.code === 200 || resp.payload?.success) {
                  toast.success("Suggested cafe deleted successfully");
                  setIsUpdated(true);
                  if (!dashUpdate) {
                    setDashUpdate(true);
                  }
                } else {
                  toast.error(
                    resp.payload?.message || "Failed to delete suggested cafe"
                  );
                }
              })
              .catch((err) => {
                toast.error("Failed to delete suggested cafe");
                console.error("Error: ", err);
              });
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  const handleUpdateSuggestionStatus = async (id, status) => {
    const statusText = status === "added" ? "Added" : "Not a fit";
    confirmAlert({
      title: "",
      message: `Are you sure you want to mark this suggestion as "${statusText}"?`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            const actionData = {
              actionUrl: `cafe/suggested-cafe/${id}/status`,
              actionMethod: "patch",
              apiData: { status },
            };
            dispatch(Entry(actionData))
              .then((resp) => {
                if (resp.payload?.code === 200 || resp.payload?.success) {
                  toast.success(`Suggestion marked as "${statusText}" successfully`);
                  setIsUpdated(true);
                  if (!dashUpdate) {
                    setDashUpdate(true);
                  }
                } else {
                  toast.error(resp.payload?.message || `Error marking suggestion as "${statusText}"`);
                }
              })
              .catch((err) => {
                toast.error(`Error marking suggestion as "${statusText}"`);
                console.error("Error: ", err);
              });
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  return (
    <>
      <div
        className={
          section === "campaignsupport"
            ? styles.btnflex
            : "col-lg-4 col-md-2 col-sm-2 col-xs-2"
        }
        id={styles.btnflex}
      >
        {/* {actionPermissions.view &&
          section !== "user" &&
          section !== "adminuser" &&
          section !== "vendor" &&
          section !== "drinktypes" &&
          section !== "cafe" &&
          section !== "menus" &&
          section !== "claimrequests" &&
          section !== "coupons" && (
            <button
              className={`${styles[actionbtnStyle]} btn btn-sm`}
              id={styles.actionbtn}
              type="button"
              onClick={actionView(data)}
            >
              {" "}
              <i className="fa fa-eye" style={{ marginRight: "5px" }} />
              View
            </button>
          )} */}

        {section !== "payoutaccounts" &&
          section !== "mergerequests" &&
          section !== "vendorapplications" &&
          section !== "orderahead" &&
          (actionPermissions.edit || actionPermissions.view) && (
            <>
              {section !== "claimrequests" &&
              section !== "enquiries" &&
              section !== "campaignsupport" &&
              section !== "issues" &&
              section !== "feedback" &&
              section !== "suggestededits" &&
              actionPermissions.edit &&
              actionPermissions.view ? (
                //  ||
                //   (section === "menus" && edit)
                <button
                  className={`${styles[actionbtnStyle]} btn btn-sm`}
                  id={styles.actionbtn}
                  type="button"
                  onClick={() => actionEdit(data)}
                >
                  <i className="fa fa-eye" style={{ marginRight: "5px" }} />
                  View/Edit
                </button>
              ) : (
                actionPermissions.view &&
                section !== "coffee credits" &&
                section !== "claimrequests" &&
                section !== "campaignsupport" && (
                  <button
                    className={`${styles[actionbtnStyle]} btn btn-sm`}
                    id={styles.actionbtn}
                    type="button"
                    onClick={() => actionEdit(data)}
                  >
                    <i className="fa fa-eye" style={{ marginRight: "5px" }} />
                    View
                  </button>
                )
              )}
            </>
          )}

        {section === "campaignsupport" && actionPermissions.view && (
          <button
            className={styles.viewbtn}
            type="button"
            title="View support request"
            aria-label="View support request"
            onClick={() => actionEdit(data)}
          >
            <i className="fa fa-eye" />
          </button>
        )}

        {/* Merge Request - View button navigates to detail page */}
        {section === "mergerequests" && actionPermissions.view && (
          <button
            className={`${styles[actionbtnStyle]} btn btn-sm`}
            id={styles.actionbtn}
            type="button"
            onClick={() => navigate(`/mergerequests/${data.id || data._id}`)}
          >
            <i className="fa fa-eye" style={{ marginRight: "5px" }} />
            View
          </button>
        )}

        {/* Vendor Applications - View button navigates to detail page */}
        {section === "vendorapplications" && actionPermissions.view && (
          <button
            className={`${styles[actionbtnStyle]} btn btn-sm`}
            id={styles.actionbtn}
            type="button"
            onClick={() => navigate(`/vendorapplications/viewdetails/${data.id || data._id}`)}
          >
            <i className="fa fa-eye" style={{ marginRight: "5px" }} />
            View
          </button>
        )}

        {section === "orderahead" && actionPermissions.view && (
          <button
            className={`${styles[actionbtnStyle]} btn btn-sm`}
            id={styles.actionbtn}
            type="button"
            onClick={() => navigate(`/orderahead/viewdetails/${data.id || data._id}`)}
          >
            <i className="fa fa-eye" style={{ marginRight: "5px" }} />
            View
          </button>
        )}

        {/* Claim Requests - View button navigates to detail page */}
        {section === "claimrequests" && actionPermissions.view && (
          <button
            className={`${styles[actionbtnStyle]} btn btn-sm`}
            id={styles.actionbtn}
            type="button"
            onClick={() => navigate(`/claimrequests/viewdetails/${data.id || data._id}`)}
          >
            <i className="fa fa-eye" style={{ marginRight: "5px" }} />
            View Details
          </button>
        )}

        {section === "menus" && edit ? (
          <button
            className={`${styles[actionbtnStyle]} btn btn-sm`}
            id={styles.actionbtn}
            type="button"
            onClick={() => actionEdit(data)}
          >
            <i className="fa fa-eye" style={{ marginRight: "5px" }} />
            View/Edit
          </button>
        ) : (
          section === "menus" && (
            <button
              className={`${styles[actionbtnStyle]} btn btn-sm`}
              id={styles.actionbtn}
              type="button"
              onClick={() => actionEdit(data)}
            >
              <i className="fa fa-eye" style={{ marginRight: "5px" }} />
              View
            </button>
          )
        )}

        {section === "cafe" && permission && !posConnected && (
          <>
            <button
              className={`${styles[actionbtnStyle]} btn btn-sm`}
              id={styles.actionbtn}
              type="button"
              onClick={() => handleDuplicateCafe(data?._id)}
            >
              Duplicate
            </button>
          </>
        )}

        {section === "cafe" && (
          <>
            <button
              className={`${styles[actionbtnStyle]} btn btn-sm`}
              id={styles.actionbtn}
              type="button"
              onClick={() => handleOrdersClickCafe(data?._id)}
            >
              Orders
            </button>
            <button
              className={`${styles[actionbtnStyle]} btn btn-sm`}
              id={styles.actionbtn}
              type="button"
              onClick={() => setShowTransactionReportModal(true)}
              aria-label={`Export reports for ${data?.name || "cafe"}`}
            >
              Reports
            </button>
          </>
        )}

        {section === "coffee credits" && (
          <>
            <button
              className={`${styles[actionbtnStyle]} btn btn-sm`}
              id={styles.actionbtn}
              type="button"
              onClick={() => handleAddCoffeeCredit(data)}
            >
              Add Coffee Reward
            </button>
          </>
        )}

        {section === "feedback" && !data?.isReplied && (
          <button
            className={`${styles[actionbtnStyle]} btn btn-sm`}
            id={styles.actionbtn}
            type="button"
            onClick={() => actionEdit(data)}
            style={{
              backgroundColor: "#28a745",
              borderColor: "#28a745",
              color: "#fff",
            }}
          >
            <i className="fa fa-reply" style={{ marginRight: "5px" }} />
            Reply
          </button>
        )}

        {section === "enquiries" && !data?.isReplied && (
          <button
            className={`${styles[actionbtnStyle]} btn btn-sm`}
            id={styles.actionbtn}
            type="button"
            onClick={() => actionEdit(data)}
            style={{
              backgroundColor: "#28a745",
              borderColor: "#28a745",
              color: "#fff",
            }}
          >
            <i className="fa fa-reply" style={{ marginRight: "5px" }} />
            Reply
          </button>
        )}

        {section === "issues" && !data?.isReplied && (
          <button
            className={`${styles[actionbtnStyle]} btn btn-sm`}
            id={styles.actionbtn}
            type="button"
            onClick={() => actionEdit(data)}
            style={{
              backgroundColor: "#28a745",
              borderColor: "#28a745",
              color: "#fff",
            }}
          >
            <i className="fa fa-reply" style={{ marginRight: "5px" }} />
            Reply
          </button>
        )}

        {section === "menus" && edit && (
          <button
            className={`${styles[actionbtnStyle]} btn btn-danger btn-sm`}
            id={styles.actionbtn1}
            type="button"
            onClick={() => {
              handleDelete(data);
            }}
          >
            {" "}
            <i className="fa fa-trash" />
          </button>
        )}

        {actionPermissions.delete && (
          <button
            className={`${styles[actionbtnStyle]} btn btn-danger btn-sm`}
            id={styles.actionbtn1}
            type="button"
            onClick={() => {
              handleDelete(data);
            }}
          >
            {" "}
            <i className="fa fa-trash" />
          </button>
        )}

        {section === "cafe" &&
          status === "Pending" &&
          permission &&
          actionPermissions.approve && (
            <>
              <button
                className={`${styles.actionbtn} btn btn-outline-success btn-sm mx-3`}
                onClick={() => handleApprove(data?._id)}
                title="Approve Cafe"
              >
                <i className="fa fa-check"></i>
              </button>
              <button
                className={`${styles[actionbtnStyle]} btn btn-outline-danger btn-sm`}
                onClick={() => handleReject(data._id)}
                title="Reject Cafe"
              >
                <i className="fa fa-times"></i>
              </button>
              <button
                className={`${styles[actionbtnStyle]} btn btn-outline-info btn-sm mx-1`}
                onClick={() => setShowSimilarCafes(true)}
                title="Find Similar Cafes"
              >
                <i className="fa fa-search"></i>
              </button>
            </>
          )}
        {section === "suggestions" && (
          <>
            {data?.status !== "added" && data?.status !== "not fit" && (
              <>
                <button
                  className={`${styles.actionbtn} btn btn-outline-success btn-sm mx-1`}
                  onClick={() => handleUpdateSuggestionStatus(data?._id || data?.id, "added")}
                  title="Mark as Added"
                  aria-label="Mark suggestion as added"
                >
                  <i className="fa fa-check"></i> Added
                </button>
                <button
                  className={`${styles.actionbtn} btn btn-outline-secondary btn-sm mx-1`}
                  onClick={() => handleUpdateSuggestionStatus(data?._id || data?.id, "not fit")}
                  title="Mark as Not a fit"
                  aria-label="Mark suggestion as not a fit"
                >
                  <i className="fa fa-times"></i> Not a fit
                </button>
              </>
            )}
            {!data?.rewarded && (
              <button
                className={`${styles.actionbtn} btn btn-outline-warning btn-sm mx-1`}
                onClick={() => handleReward(data?._id || data?.id)}
                title="Reward $100"
                aria-label="Reward user $100"
              >
                <i className="fa fa-gift"></i> Reward $100
              </button>
            )}
            {data?.status === "added" && (
              <span className="badge bg-success mx-1">Added</span>
            )}
            {data?.status === "not fit" && (
              <span className="badge bg-secondary mx-1">Not fit</span>
            )}
            <button
              className={`${styles.actionbtn} btn btn-outline-danger btn-sm mx-1`}
              onClick={() =>
                handleDeleteSuggestion(
                  data?._id || data?.id,
                  data?.cafeName
                )
              }
              title="Delete suggestion"
              aria-label="Delete suggested cafe"
            >
              <i className="fa fa-trash"></i> Delete
            </button>
          </>
        )}

        {section === "user" && (
          <>
            <button
              className={`${styles[actionbtnStyle]} btn btn-sm`}
              id={styles.actionbtn}
              type="button"
              onClick={() => setShowWalletModal(true)}
              aria-label="View wallet balance"
            >
              <i className="fa fa-wallet" style={{ marginRight: "5px" }} />
              Wallet
            </button>
            <button
              className="btn btn-outline-danger btn-sm"
              onClick={() => handleOrdersClick(data?._id || data.id)}
            >
              Orders
            </button>
          </>
        )}
      </div>

      {/* Conditional Popup based on action and section */}
      {showTablePopUp &&
        (section === "user" ? (
          action === "edit" && actionPermissions?.edit ? (
            <EditUserPopup
              userId={data.id}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : (
            actionPermissions?.view && (
              <EditUserPopup
                userId={data.id}
                handleClose={setShowTablePopUp}
                setIsUpdated={setIsUpdated}
                edit={false}
              />
            )
          )
        ) : section === "vendor" ? (
          action === "edit" && actionPermissions?.edit ? (
            <EditVendorPopup
              vendorId={data.id}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : (
            actionPermissions?.view && (
              <EditVendorPopup
                vendorId={data.id}
                handleClose={setShowTablePopUp}
                setIsUpdated={setIsUpdated}
                edit={false}
              />
            )
          )
        ) : section === "adminuser" ? (
          action === "edit" && actionPermissions?.edit ? (
            <EditAdminUserPopup
              userId={data.id}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : (
            actionPermissions?.view && (
              <EditAdminUserPopup
                userId={data.id}
                handleClose={setShowTablePopUp}
                setIsUpdated={setIsUpdated}
                edit={false}
              />
            )
          )
        ) : section === "cafe" ? (
          action === "edit" && actionPermissions?.edit ? (
            <EditCafePopup
              setTableData={setTableData}
              cafeId={data._id}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : (
            actionPermissions?.view && (
              <EditCafePopup
                setTableData={setTableData}
                cafeId={data._id}
                handleClose={setShowTablePopUp}
                setIsUpdated={setIsUpdated}
                edit={false}
              />
            )
          )
        ) : section === "drinktypes" ? (
          action === "edit" && actionPermissions?.edit ? (
            <EditDrinkTypePopup
              drinkTypeId={data.id}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : (
            <EditDrinkTypePopup
              drinkTypeId={data.id}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
              edit={false}
            />
          )
        ) : section === "category" ? (
          action === "edit" && actionPermissions?.edit ? (
            <EditCategoryPopup
              categoryId={data.id || data?._id}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : (
            <EditCategoryPopup
              categoryId={data.id || data?._id}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
              edit={false}
            />
          )
        ) : section === "coupons" ? (
          action === "edit" && actionPermissions?.edit ? (
            <EditCouponPopUp
              data={data}
              couponId={data.id}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : (
            <EditCouponPopUp
              data={data}
              couponId={data.id}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
              edit={false}
            />
          )
        ) : section === "menus" ? ( // Add Menu section here
          action === "edit" && edit ? (
            <MenuEdit
              menuId={data.id}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : (
            <MenuEdit
              menuId={data.id}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
              edit={false}
            />
          )
        ) : section === "feedback" && actionPermissions?.view ? (
          <ViewFeedbackPopup
            feedbackId={data.id}
            handleClose={setShowTablePopUp}
            setIsUpdated={setIsUpdated}
          />
        ) : section === "suggestions" && actionPermissions?.view ? (
          <ViewSuggestionPopup
            suggestionId={data.id}
            handleClose={setShowTablePopUp}
            setIsUpdated={setIsUpdated}
          />
        ) : section === "suggestededits" && actionPermissions?.view ? (
          <ViewSuggestedEditPopup
            suggestionId={data.id}
            handleClose={setShowTablePopUp}
          />
        ) : section === "payouts" && actionPermissions?.view ? (
          <ViewPayoutPopup
            payoutId={data.id}
            handleClose={setShowTablePopUp}
            setIsUpdated={setIsUpdated}
          />
        ) : section === "enquiries" && actionPermissions?.view ? (
          <ViewEnquiryPopup
            contactUsId={data.id}
            handleClose={setShowTablePopUp}
            setIsUpdated={setIsUpdated}
          />
        ) : section === "campaignsupport" && actionPermissions?.view ? (
          <ViewCampaignSupportPopup
            supportId={data.id || data._id}
            handleClose={setShowTablePopUp}
          />
        ) : section === "tickets" && actionPermissions?.view ? (
          <ViewTicketPopup ticketId={data.id} handleClose={setShowTablePopUp} />
        ) : section === "issues" && actionPermissions?.view ? (
          <ViewIssuePopup
            data={data}
            issueId={data?.id || data?._id}
            handleClose={setShowTablePopUp}
            setIsUpdated={setIsUpdated}
          />
        ) : section === "participationrequests" && actionPermissions?.view ? (
          <ParticipationReqPopup
            data={data}
            cafeId={data?.id || data?._id}
            handleClose={setShowTablePopUp}
            setIsUpdated={setIsUpdated}
          />
        ) : section === "coffee credits" ? (
          <CoffeeRewardPopup
            userDetails={data}
            handleClose={setShowTablePopUp}
            setIsUpdated={setIsUpdated}
          />
        ) : section === "app versions" ? (
          action === "edit" && actionPermissions?.edit ? (
            <EditAppVersionPopup
              appVersionId={data.id || data._id}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : (
            <EditAppVersionPopup
              appVersionId={data.id || data._id}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
              edit={false}
            />
          )
        ) : (
          <TableViewPopup
            dataId={data.id}
            handleClose={setShowTablePopUp}
            section={section}
          />
        ))}

      {showTablePopUp && selectedCafeId && (
        <EditCafePopup
          setTableData={setTableData}
          cafeId={selectedCafeId}
          handleClose={setShowTablePopUp}
          setIsUpdated={setIsUpdated}
        />
      )}

      {showOrdersPopup && (
        <OrdersPopup
          userId={selectedUserId}
          type={selectedType}
          handleClose={() => {
            setShowOrdersPopup(false);
            setSelectedUserId(null);
          }}
        />
      )}

      {showTransactionReportModal && section === "cafe" && (
        <CafeTransactionReportModal
          show={showTransactionReportModal}
          cafeId={data?._id || data?.id}
          cafeName={data?.name}
          handleClose={() => setShowTransactionReportModal(false)}
        />
      )}

      {showWalletModal && section === "user" && (
        <WalletBalanceModal
          userId={data?._id || data?.id}
          userName={data?.name}
          handleClose={() => setShowWalletModal(false)}
          setIsUpdated={setIsUpdated}
        />
      )}

      {/* Find Similar Cafes Modal */}
      {showSimilarCafes && (
        <FindSimilarCafesModal
          show={showSimilarCafes}
          handleClose={() => setShowSimilarCafes(false)}
          cafeId={data._id}
          onSelectCafe={handleSelectCafeForMerge}
        />
      )}

      {/* Suggest Merge Modal */}
      {showSuggestMerge && (
        <SuggestMergeModal
          show={showSuggestMerge}
          handleClose={() => {
            setShowSuggestMerge(false);
            setSelectedTargetCafe(null);
          }}
          sourceCafeId={data._id}
          sourceCafe={data}
          targetCafe={selectedTargetCafe}
          onSuccess={() => {
            setShowSuggestMerge(false);
            setSelectedTargetCafe(null);
            setIsUpdated(true);
            if (!dashUpdate) {
              setDashUpdate(true);
            }
          }}
        />
      )}
    </>
  );
}

ActionButtons.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
  section: PropTypes.string.isRequired,
  viewPopUp: PropTypes.bool.isRequired,
  deleteCondition: PropTypes.oneOfType([PropTypes.object]),
};

ActionButtons.defaultProps = {
  deleteCondition: { checkCondition: false, apiUrl: "none" },
};

export default ActionButtons;
